import { ConfirmDialog } from '@/components/modals/ConfirmationModal';
import { ModalsManager } from '@/components/modals/modalsManager';
import { Switch } from '@/components/ui/Switch';

import { useSetTrustedMutation } from './edits.query';

import type { WikiPerson } from '../people-wiki.types';

const confirmTrust = async (name: string): Promise<boolean> =>
  Boolean(
    await ModalsManager.showResolvable(ConfirmDialog, {
      title: `Trust ${name}?`,
      description: `${name}'s agent will be able to talk to your agent without asking you first, and your agent will answer from your Littlebird memory. Only trust people you would share your work with. You can turn this off at any time.`,
      confirmText: `Trust ${name}`,
      cancelText: 'Cancel',
      confirmVariant: 'destructive',
    })
  );

export const TrustedCell = ({ person }: { person: WikiPerson }) => {
  const { mutate: setTrusted, isPending } = useSetTrustedMutation(person.id);
  const onCheckedChange = async (trusted: boolean) => {
    if (trusted && !(await confirmTrust(person.name))) return;
    setTrusted(trusted);
  };
  return (
    <Switch
      checked={person.isTrusted}
      disabled={isPending}
      onCheckedChange={onCheckedChange}
      // The row opens the person page on click
      onClick={(event) => event.stopPropagation()}
      aria-label={`Trust ${person.name}`}
    />
  );
};
